import { AxiosError } from 'axios';

export const AccountPayableErrors: Record<string, string> = {
  'financial.errors.installment.payable.already.edited.situation':
    'Parcela já foi alterada o status, recarregaremos a tela!',
};

export function handleInstallmentAlreadyEdited(error: AxiosError) {
  if (
    error.response?.data.message?.includes(
      'financial.errors.installment.payable.already.edited.situation',
    )
  ) {
    return true;
  }
  return false;
}
